import { render, staticRenderFns } from "./sales-deliveries-carousel-sheet.vue?vue&type=template&id=7aa496af&"
import script from "./sales-deliveries-carousel-sheet.component.ts?vue&type=script&lang=ts&"
export * from "./sales-deliveries-carousel-sheet.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports